import { FormikProps } from 'formik';
import React from 'react';
import Button from '../Button';
import { VersionSupportType } from '../../pages/Settings';
import Input from '../Input';
import Select from '../Select';

interface PropTypes {
  formik: FormikProps<VersionSupportType>;
}

const VersionSupportForm = ({ formik }: PropTypes) => {
  return (
    <form onSubmit={formik.handleSubmit}>
      <h1 className='text-lg font-semibold mt-10 mb-2'>Version support</h1>
      <div className='lg:grid lg:grid-cols-5 lg:gap-10'>
        <Input
          id='latest_version'
          label='Latest version *:'
          name='latestVersion'
          className='h-14 px-4 text-sm focus:outline-none'
          placeholder='0.0.1'
          value={formik.values.latestVersion}
          onChange={formik.handleChange}
          labelClassName='text-[16px] lg:text-[16px]'
        />

        <Input
          id='build_number'
          type='number'
          label='Build number *:'
          min={0}
          name='buildNumber'
          className=' h-14  px-4 text-sm focus:outline-none'
          placeholder='Enter build number'
          value={formik.values.buildNumber}
          onChange={formik.handleChange}
          labelClassName='text-[16px] lg:text-[16px]'
        />

        <Select
          name='platform'
          defaultValue=''
          label='Platform required *:'
          placeholder='Select a platform'
          onChange={formik.handleChange}
          value={formik.values.platform}
          className='h-14 lg:w-48  px-4 text-sm'
          id='platform_required'
          options={[
            { label: 'Android', value: 'android' },
            { label: 'iOS', value: 'ios' },
          ]}
          labelClassName='text-[16px] lg:text-[16px]'
        />

        <Select
          name='isUpdateRequired'
          label='Update required *:'
          onChange={formik.handleChange}
          value={formik.values.isUpdateRequired}
          className='h-14 lg:w-48  px-4 text-sm'
          id='update_required'
          options={[
            { label: 'No', value: '0' },
            { label: 'Yes', value: '1' },
          ]}
          labelClassName='text-[16px] lg:text-[16px]'
        />


        <Select
          label='User type *:'
          value={formik.values.userType}
          className='h-14 lg:w-48  px-4 text-sm'
          id='user_type'
          name='userType'
          onChange={formik.handleChange}
          options={[
            { label: 'User', value: 'user' },
            { label: 'Driver', value: 'driver' },
          ]}
          labelClassName='text-[16px] lg:text-[16px]'
        />
      </div>

      {Object.keys(formik.errors).length > 0 && (
        <div className='text-red-500 mt-4'>
          <p>{Object.values(formik.errors)[0]}</p>
        </div>
      )}

      <div className='w-full flex justify-center lg:justify-start mt-4'>
        <Button className="w-full md:w-32 min-h-0 h-10 md:h-10" isLoading={formik.isSubmitting}>
          Save
        </Button>
      </div>
    </form>
  );
};

export default VersionSupportForm;
